import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiMethod } from '../../apimethods/api-method';
import { BioRxivAPIModel } from './biorxiv-model';
import * as ngswal from "sweetalert";
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
declare var $;

@Component({
  selector: 'app-biorxiv',
  templateUrl: './biorxiv.component.html',
  styleUrls: ['./biorxiv.component.css']
})

/** bio-rxiv component*/
export class BioRxivComponent implements OnInit {
  /** bio-rxiv ctor */
  modelItem = new BioRxivAPIModel();
  dataTable: any; dataSet: any; @ViewChild('dataTable', { static: false }) table;
  dataTableVendor: any; dataSetVendor: any; @ViewChild('dataTableVendor', { static: false }) tableVendor;
  today: any = new Date();
  yesterday: any = new Date();
  previousMonth: any = new Date();
  OverAllArticles: number;
  OverAllPages: number;
  OverAllBatch: string;
  TodayArticles: number;
  TodayPages: number;
  TodayBatch: string;
  YesterdayArticles: number;
  YesterdayPages: number;
  YesterdayBatch: string;
  CurrentMonthArticles: number;
  CurrentMonthPages: number;
  CurrentMonthBatchCount: string;
  PreviousMonthArticles: number;
  PreviousMonthPages: number;
  PreviousMonthBatchCount: string;
  CurrentYearArticles: number;
  CurrentYearPages: number;
  CurrentYearBatchCount: string;


  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <BioRxivAPIModel>data["BioRxivPage"];

        this.GetArticledata();
        this.NTProcessLoadDataList();
        this.VendorProcessLoadDataList();
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  ngOnInit() {
    customfunctions.SetDateValues('#Txt_FromDate', '#Txt_ToDate');

    this.yesterday.setDate(this.yesterday.getDate() - 1)
    this.previousMonth.setMonth(this.previousMonth.getMonth() - 1)
    ApiMethod.getBaseUrl();

    setInterval(function () {
      $('#btnAutoLoad').trigger('click');
    }, 300000);

  }
  LoadSummaryData() {
    this.GetArticledata(true);
  }
  LoadGridData() {
    this.NTProcessLoadDataList(true);
    this.VendorProcessLoadDataList(true);
  }
  GetArticledata(autoLoad = false) {
    if (autoLoad = false) {
      $("#LoadingImage").show();
    }

    var Articledate = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
    };

    ApiMethod.postMethod(this.modelItem.BioDashboardSummaryAPI, Articledate).subscribe(
      Response => {

        var items = Response.aArticleData
        if (items.length > 0) {
          for (let i = 0; i < items.length; i++) {
            try {
              if (items[i].Type == 'Today') {
                this.TodayArticles = items[i].ArticleCount == null ? 0 : items[i].ArticleCount;
                this.TodayPages = items[i].PagesCount == null ? 0 : items[i].PagesCount;
                this.TodayBatch = items[i].Batch == null ? "Batch_#" : items[i].Batch;
              }
              if (items[i].Type == 'Yesterday') {
                this.YesterdayArticles = items[i].ArticleCount == null ? 0 : items[i].ArticleCount;
                this.YesterdayPages = items[i].PagesCount == null ? 0 : items[i].PagesCount;
                this.YesterdayBatch = items[i].Batch == null ? "Batch_#" : items[i].Batch;
              }
              if (items[i].Type == 'CurrentMonth') {
                this.CurrentMonthArticles = items[i].ArticleCount == null ? 0 : items[i].ArticleCount;
                this.CurrentMonthPages = items[i].PagesCount == null ? 0 : items[i].PagesCount;
                this.CurrentMonthBatchCount = items[i].Batch == null ? "Batch_#" : items[i].Batch;
              }
              if (items[i].Type == 'PreviousMonth') {
                this.PreviousMonthArticles = items[i].ArticleCount == null ? 0 : items[i].ArticleCount;
                this.PreviousMonthPages = items[i].PagesCount == null ? 0 : items[i].PagesCount;
                this.PreviousMonthBatchCount = items[i].Batch == null ? "Batch_#" : items[i].Batch;
              }
              if (items[i].Type == 'Overall') {
                this.OverAllArticles = items[i].ArticleCount == null ? 0 : items[i].ArticleCount;
                this.OverAllPages = items[i].PagesCount == null ? 0 : items[i].PagesCount;
                this.OverAllBatch = items[i].Batch == null ? "Batch_#" : items[i].Batch;
              }
              if (items[i].Type == 'CurrentYear') {
                this.CurrentYearArticles = items[i].ArticleCount == null ? 0 : items[i].ArticleCount;
                this.CurrentYearPages = items[i].PagesCount == null ? 0 : items[i].PagesCount;
                this.CurrentYearBatchCount = items[i].Batch == null ? "Batch_#" : items[i].Batch;
              }
            } catch (e) {
              console.log(e);
            }
          }
        }
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        console.log(error.message);
      });
  }
  NTProcessLoadDataList(autoLoad = false): void {
    if (autoLoad = false) {
      $("#LoadingImage").show();
    }
    var paramData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      ModuleName: "NTWIPArticle"
    };

    ApiMethod.postMethod(this.modelItem.GetNTProcessArticleList, paramData).subscribe(
      result => {
        this.dataSet = JSON.stringify(result.aArticleData); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 330);
        dataItem.modulename = 'NTWIPArticle';
        dataItem.infoPopupID = 'ID';
        dataItem.defaultPagesize = -1;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        console.log(error.message);
      });
  }
  VendorProcessLoadDataList(autoLoad = false): void {
    if (autoLoad = false) {
      $("#LoadingImage").show();
    }
    var paramData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      ModuleName: "VendorWIPArticle"
    };

    ApiMethod.postMethod(this.modelItem.GetVendorProcessArticleList, paramData).subscribe(
      result => {
        this.dataSetVendor = JSON.stringify(result.aArticleData); // Data List
        this.dataSetVendor = JSON.parse(this.dataSetVendor);
        this.dataTableVendor = $(this.tableVendor.nativeElement);

        //Dynamic datable
        let aColList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTableVendor;
        dataItem.dataset = this.dataSetVendor;
        dataItem.dtheight = (GlobalConstants.size.height - 330);
        dataItem.modulename = 'VendorWIPArticle';
        dataItem.infoPopupID = 'ID';
        dataItem.defaultPagesize = -1;
        this.dataTableVendor = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
       console.log(error.message);
      });
  }
}
